import $ from 'jquery'
import initLongAccordion from './long-accordion'

const $doc = $(document)

function toggleAccordionItem() {
  let el = $(this);
  if ( el.parent().parent().hasClass('active') ) {
    el.attr('aria-expanded', 'false');
  } else {
    el.attr('aria-expanded', 'true');
  }
  el.parent().next().slideToggle('fast');
  el.parent().parent().toggleClass('active');
}

$doc.on('click', '.js-accordion-item:not(.js-accordion-item-long) button', toggleAccordionItem )

// Init long accordions
initLongAccordion()
